<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("boxScan.scanIn")}}
      </div>
      <div class="btn-group pull-right">
        <el-tooltip effect="dark" content="导出当前的扫描信息，可用于下次导入" placement="top">
          <div class="inline-button-wrapper">
            <el-button :plain="true" size="mini" @click="exportScanInfos" :disabled="!hasScanned">{{ $t("boxScan.exportScanInfos") }}
              <i class="fa fa-download"></i>
            </el-button>
          </div>
        </el-tooltip>

        <el-upload action="" class="inline-button-wrapper" accept=".json" :before-upload="importScanInfos" :limit="1" :show-file-list="false">
          <el-tooltip effect="dark" content="导入扫描信息" placement="top">
            <el-button :plain="true" size="mini">{{ $t("boxScan.importScanInfos") }}
              <i class="fa fa-upload"></i>
            </el-button>
          </el-tooltip>
        </el-upload>

        <el-button :plain="true" size="mini" @click="backToScanRecord">{{ $t("boxScan.viewScanRecord") }}
          <i class="fa fa-list-ul"></i>
        </el-button>
        <el-button :plain="true" type="primary" size="mini" @click="commitScanInfo" :disabled="!hasScanned">{{ $t("boxScan.commitScanInfo") }}
          <i class="fa fa-hand-pointer-o"></i>
        </el-button>

        <el-button type="warning" :plain="true" size="mini" @click="clearScanInfo" :disabled="!hasScanned">{{ $t("reset") }}
          <i class="fa fa-eraser"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list">
      <div class="scan-input">
        <el-form class="search-form" status-icon>
          <el-form-item v-show="canScanBoxNumber">
            <el-input ref="boxNumberInput" :placeholder="$t('boxScan.scanBoxNumber')" v-model="currentBoxNumber" @keydown.native.enter="commitBoxNumber" @blur="scanInputBlur" :disabled="loadingInput" :suffix-icon="loadingIcon">
              <span slot="prepend">
                {{prependTitle}}
              </span>
            </el-input>
          </el-form-item>
          <el-form-item v-show="canScanEanCode">
            <el-input ref="eanCodeInput" :placeholder="$t('boxScan.scanEanCode')" v-model="scanOnly.eanCode" @keydown.native.enter="commitEanCode" @blur="scanInputBlur" :disabled="loadingInput" :suffix-icon="loadingIcon">
              <span slot="prepend">
                {{prependTitle}}
              </span>
            </el-input>
          </el-form-item>
          <el-form-item v-show="canScanQRCode">
            <el-input ref="qrCodeInput" :placeholder="$t('boxScan.scanQRCode')" v-model="scanOnly.qrCode" @keydown.native.enter="commitQRCode" @blur="scanInputBlur" :disabled="loadingInput" :suffix-icon="loadingIcon">
              <span slot="prepend">
                {{prependTitle}}
              </span>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="scan-info">
        <div class="boxNumber">
          {{this.$t('boxScan.currentBoxNumber')}} {{this.currentBoxNumber}} &nbsp;&nbsp;&nbsp;
          {{this.$t('boxScan.currentNumber')}} {{this.scanEntries.length}}
        </div>
        <el-table border stripe :data="scanEntries" size="mini" class="customer-table">

          <el-table-column prop="eanCode" align="center" :resizable="true" :label="this.$t('boxScan.eanCode')">
          </el-table-column>

          <el-table-column prop="eanCodeInfo.ProductLongCode" align="center" :resizable="true" :label="this.$t('boxScan.productLongCode')">
          </el-table-column>

          <el-table-column prop="qrCode" align="center" :resizable="true" :label="this.$t('boxScan.qrCode')">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- confirm dialog  -->
    <el-dialog class="search-dialog" :title="this.$t('boxScan.submitDialogTitle')" :visible.sync="submitDialogVisible" width="40%">
      <el-table size="mini" :stripe="true" :data="scanSubmitEntries" :show-summary="true" :summary-method="getSummaries">
        <el-table-column property="boxNumber" align="center" :label="this.$t('boxScan.boxNumber')"></el-table-column>

        <el-table-column property="productLongCode" align="center" :label="this.$t('boxScan.productLongCode')"></el-table-column>

        <el-table-column property="count" align="center" :label="this.$t('boxScan.productBoxCount')"></el-table-column>

        <el-table-column property="productCount" align="center" :label="this.$t('boxScan.productCount')"></el-table-column>

        <el-table-column align="center" :label="this.$t('operation')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('boxScan.clearEanScanInfo')" placement="top">
              <el-button type="text" class="delete-btn" @click="clearEanScanInfo(scope.row.eanCode)">
                <i class="fa fa-trash"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div slot="footer" class="search-footer">
        <el-button @click="submitDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
        <el-button type="primary" @click="commit" :loading="processCommit" :plain="true" size="mini">{{this.$t('submit')}}</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>
<script>
import scanFlag from "./scanFlag";
import scanInfoService from "./scanInfoService";
import qrcodeService from "../../../services/qrcodeService";
import fileSaver from "file-saver";
import { Message } from 'element-ui';
import { fromEvent, from, Observable, of, Subject, forkJoin } from "rxjs";
import { map, scan, catchError, timeout } from 'rxjs/operators';
import { messageService } from './messageService';

export default {
  name: "ScanInfo",
  data() {
    return {
      submitDialogVisible: false,
      loading: true,
      filter: {},
      filterOptions: [],
      scanEntries: [],
      scanSubmitEntries: [],
      currentBoxNumber: "",
      loadingInput: false,
      processCommit: false,
       scanOnly: {
        boxNumber: "",
        eanCode: "",
        qrCode: ""
      },
      scanInfo: {
        boxNumber: "",
        eanCode: "",
        qrCode: ""
      },
      eanCodeInfos: [],
      scanFlag: scanFlag.BOXNUMBER,
      focusItemRef: "boxNumberInput"
    };
  },
  methods: {
    sendMessage() {
      messageService.sendMessage('Message from Home Page Component to App Component!');
    },
    clearMessages() {
      messageService.clearMessages();
    },
    commitBoxNumber() {
      if (this.currentBoxNumber) {
        if (this.currentBoxNumber.length == 8) {
          this.currentBoxNumber = "00000000" + this.currentBoxNumber + new Date().getFullYear();
        }
        //if (this.currentBoxNumber.length !== 20) {
          //this.$alert(this.$t("boxScan.boxNumberFormatterError"), "错误", {
            //type: "error",
            //callback: action => {
             // this.currentBoxNumber = "";
            //},
            
          //});
          //return;
        //}
        this.loadingInput = true;
        this.$axios
          .get(`api/qrc/existboxnumber/${this.currentBoxNumber}`)
          .then(resp => {
            if (resp.data) {
              this.$alert(
                this.$t("boxScan.boxNumberScanned", {
                  boxNumber: this.currentBoxNumber
                }),
                "错误",
                {
                  type: "error",
                  callback: action => {
                    this.currentBoxNumber = "";
                  }
                }
              );
            } else {
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
            }
            this.loadingInput = false;
          })
          .catch(e => {
            this.loadingInput = false;
          });
      }
    },
    commitEanCode() {
      let code = this.scanOnly.eanCode;
      if (!code) return;
  
      console.log("commitEanCode", this.scanOnly.eanCode);
      if (code.includes('https:') || code.includes('http:') || code.includes('?') || code.includes('.') || code.includes('=')) {
        this.$alert(`EAN码不合法：${code}`,"错误", {
          type: "error",
          callback: action => {
            this.scanOnly.eanCode = "";
          }
        });

        return;
      }

      let codeInfo = this.eanCodeInfos.find(c => c.EANCode === code);
      if (codeInfo) {
        this.scanOnly.eanCodeInfo = codeInfo;
        this.scanFlag = scanFlag.QRCODE;
        this.focusItemRef = "qrCodeInput";
        return;
      }

      //this.eanCodeInfos.push(resp.data);
      //this.scanInfo.eanCodeInfo = resp.data;
      this.scanFlag = scanFlag.QRCODE;
      this.focusItemRef = "qrCodeInput";

      //console.log("ean:", this.scanOnly, this.eanCodeInfos, this.focusItemRef)

      /*
      this.loadingInput = true;
      this.$axios
        .get(`api/eancodes/bycode/${code}`)
        .then(resp => {
          console.log("Res", resp);
          if (resp.data) {
            console.log("commitEanCode-backData");
            this.eanCodeInfos.push(resp.data);
            this.scanInfo.eanCodeInfo = resp.data;
            this.scanFlag = scanFlag.QRCODE;
            this.focusItemRef = "qrCodeInput";
          } else {
            console.log("commitEanCode-ErrorData");
            this.$alert(`${this.$t("boxScan.eanCheckFail")}：${code}`, "错误", {
              type: "error",
              callback: action => {
                this.scanInfo.eanCode = "";
              }
            });
          }
          this.loadingInput = false;
        })
        .catch(e => {
          this.$alert(this.$t("boxScan.eanCheckFail"), "提示", {
            type: "error"
          });
          this.loadingInput = false;
        });
      */
    },
    commitQRCode() {
      //console.log("commitQRCodeBefore:" + this.scanOnly.qrCode);
      let codeUrl = this.scanOnly.qrCode;
      if (codeUrl.includes('https:') || codeUrl.includes('http:')) {
        if (!codeUrl.includes('?code')) {
          this.$alert(`二维码不合法：${codeUrl}`,"错误",
          {
            type: "error",
            callback: action => {
              this.scanOnly.qrCode = "";
            }
          });

          return;
        } else {
          this.scanOnly.qrCode = this.scanOnly.qrCode.substring(this.scanOnly.qrCode.indexOf('=') + 1);
        }
      } else if (codeUrl.includes('.')) {
        this.$alert(`二维码不合法：${codeUrl}`, "错误",
            {
              type: "error",
              callback: action => {
                this.scanOnly.qrCode = "";
              }
            });

        return;
      }

      //let code = qrcodeService.getQRCode(codeUrl);
      //console.log("commitQRCodeAfter: " + code);
      //console.log("commitQRCodeInfo", this.scanOnly);
      //this.scanOnly.qrCode = code;
      //if (!code) return;

      if (this.scanEntries.find(s => s.qrCode === this.scanOnly.qrCode)) {
        this.loadingInput = true;
        this.$alert(`${this.$t("boxScan.duplicateQRCode")}：${this.scanOnly.qrCode}`, "错误", {
          type: "error",
          callback: action => {
            this.scanOnly.qrCode = "";
            this.loadingInput = false;
          }
        });

        return;
      }

      this.scanOnly.boxNumber = this.currentBoxNumber;

      messageService.sendMessage(this.scanOnly);//todo
      this.scanFlag = scanFlag.EANCODE;
      this.focusItemRef = "eanCodeInput";
      //this.scanOnly.boxNumber = this.currentBoxNumber;
      //this.scanEntries.splice(0, 0, this.scanOnly);
      this.scanOnly = {};
      //scanInfoService.write(this.scanEntries);

      return;

      //todo 验证 调用folkjoin接口,验证通过，加入列表，不通过提示，
      //EAN QRcode结束时subject.next()
      forkJoin(this.$axios.get(`api/eancodes/bycode/${this.scanInfo.eanCode}`), this.$axios.get(`api/qrc/${this.scanInfo.qrCode}`)).subscribe(result => {
        console.log("EAN-QR:", result);
        //debugger;
        if (result[0].data) {
          this.eanCodeInfos.push(result[0].data);
          this.scanInfo.eanCodeInfo = result[0].data;
          //this.scanFlag = scanFlag.QRCODE;
          //this.focusItemRef = "qrCodeInput";
        } else {
          console.log("commitEanCode-ErrorData");
          this.$alert(`${this.$t("boxScan.eanCheckFail")}：${this.scanInfo.eanCode}`, "错误", {
            type: "error",
            callback: action => {
              this.scanInfo.eanCode = "";
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
              this.scanInfo.qrCode = "";
              console.log("commitQRCodeInfo", this.scanInfo);
            }
          });

          return;
        }

        if (result[1].data) {
          if (result[1].data.Status < 2) {
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
              this.scanInfo.boxNumber = this.currentBoxNumber;
              this.scanEntries.splice(0, 0, this.scanInfo);
              this.scanInfo = {};
              scanInfoService.write(this.scanEntries);
            } else {
              console.log("commitQRCode-errorData");
           
              this.$alert(`${this.$t("boxScan.qrcodeShippedError")}：${code}`, "错误",
                {
                  type: "error",
                  callback: action => {
                    this.scanInfo.qrCode = "";
                  }
                });
            }
        } else {
            this.$alert(`${this.$t("boxScan.qrcodeCheckFail")}：${this.scanInfo.qrCode}`, "错误",
              {
                type: "error",
                callback: action => {
                  this.scanInfo.qrCode = "";
                }
              });
          }
          this.loadingInput = false;
      },
      error => {
        debugger;
        console.error('EAN QRCode检查失败');
        this.scanFlag = scanFlag.EANCODE;
        this.focusItemRef = "eanCodeInput";
        this.scanInfo.qrCode = "";
        this.scanInfo.eanCode = "";
        this.$alert('EAN QRCode检查失败', "提示", {
          type: "error"
        });
      });

      /*
      this.loadingInput = true;
      this.$axios
        .get(`api/qrc/${code}`)
        .then(resp => {
          console.log("Res", resp);
          if (resp.data) {
            console.log("commitQRCode-backData" + resp.data.Status );
          
            if (resp.data.Status < 2) {
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
              this.scanInfo.boxNumber = this.currentBoxNumber;
              this.scanEntries.splice(0, 0, this.scanInfo);
              this.scanInfo = {};
              scanInfoService.write(this.scanEntries);
            } else {
              console.log("commitQRCode-errorData");
           
              this.$alert(
                `${this.$t("boxScan.qrcodeShippedError")}：${code}`,
                "错误",
                {
                  type: "error",
                  callback: action => {
                    this.scanInfo.qrCode = "";
                  }
                 }
              );
            }
          } else {

            this.$alert(
              `${this.$t("boxScan.qrcodeCheckFail")}：${code}`,
              "错误",
              {
                type: "error",
                callback: action => {
                  this.scanInfo.qrCode = "";
                }
              }
            );
          }
          this.loadingInput = false;
        })
        .catch(e => {});
      */
    },
    searchEanQRCode(info) {
      console.log("查询", info.boxNumber, info.eanCode, info.qrCode);
      //return;

      forkJoin(this.$axios.get(`api/eancodes/bycode/${info.eanCode}`), this.$axios.get(`api/qrc/${info.qrCode}`)).pipe(
        timeout(2500),
        // 处理超时发出的错误
        catchError((error) => {
          console.error('forkJoin timed out!');
          // 你可以在这里处理超时后的逻辑，比如通知用户或者重试等
          //return 'timeout'; // 返回一个值来结束Observable
        })
      ).subscribe(result => {
        console.log("EAN-QR:", info.eanCode, info.qrCode, result);
        //debugger;
        let resultScan = { boxNumber: "", eanCode: "", qrCode: "" };

        if (result[0].data) {
          this.eanCodeInfos.push(result[0].data);
          this.scanInfo.eanCodeInfo = result[0].data;
          this.scanInfo.eanCode = info.eanCode;
          //this.scanFlag = scanFlag.QRCODE;
          //this.focusItemRef = "qrCodeInput";
        } else {
          console.log("commitEanCode-ErrorData333");
          this.loadingInput = true;
          this.$alert(`${this.$t("boxScan.eanCheckFail")}：${info.eanCode}`, "错误", {
            type: "error",
            callback: action => {
              this.scanInfo.eanCode = "";
              this.scanFlag = scanFlag.EANCODE;
              this.focusItemRef = "eanCodeInput";
              this.scanInfo.qrCode = "";
              this.loadingInput = false;
              console.log("commitQRCodeInfo", this.scanInfo);
            }
          });
          
          return;
        }

        if (result[1].data) {
          if (result[1].data.Status < 2) {
              //this.scanFlag = scanFlag.EANCODE;
              //this.focusItemRef = "eanCodeInput";
              this.scanInfo.qrCode = info.qrCode;
              this.scanInfo.boxNumber = this.currentBoxNumber;
              this.scanEntries.splice(0, 0, this.scanInfo);
              this.scanInfo = {};
              scanInfoService.write(this.scanEntries);
            } else {
              console.log("commitQRCode-errorData");
              this.loadingInput = true;
              this.$alert(`${this.$t("boxScan.qrcodeShippedError")}：${info.qrCode}`, "错误",
                {
                  type: "error",
                  callback: action => {
                    this.scanInfo.qrCode = "";
                  }
                });
            }
        } else {
            this.loadingInput = true;
            this.$alert(`${this.$t("boxScan.qrcodeCheckFail")}：${info.qrCode}`, "错误",
              {
                type: "error",
                callback: action => {
                  this.scanInfo.qrCode = "";
                }
              });
        }
        this.loadingInput = false;
      },
      error => {
        //debugger;
        console.error('EAN QRCode检查失败', info.qrCode);
        this.loadingInput = true;
        this.$alert('EAN QRCode检查失败 ' + info.qrCode, "提示", {
          type: "error"
        });

        this.scanFlag = scanFlag.EANCODE;
        this.focusItemRef = "eanCodeInput";
        this.scanInfo.qrCode = "";
        this.scanInfo.eanCode = "";
        this.loadingInput = false;
      });
    },
    commitScanInfo() {
      console.log("commitScanInfo");
      this.scanSubmitEntries = scanInfoService.groupBy(this.scanEntries);
      this.submitDialogVisible = true;
    },
    commit() {
      console.log("commit");
      this.processCommit = true;
      this.$axios
        .post("api/delivery/boxScan", this.scanEntries)
        .then(resp => {
          this.$message({
            showClose: true,
            message: this.$t("boxScan.commitScanInfoSuccess"),
            type: "success"
          });
          this.submitDialogVisible = false;
          this.processCommit = false;
          this.scanEntries = [];
          this.resetBoxNumber();
          scanInfoService.clear();
        })
        .catch(e => {
          let msg =
            (e.response && e.response.data) ||
            this.$t("boxScan.commitScanInfoError");
          this.$message({
            showClose: true,
            message: msg,
            type: "error"
          });
          this.processCommit = false;
        });
    },
    resetBoxNumber() {
      this.currentBoxNumber = "";
      this.scanFlag = scanFlag.BOXNUMBER;
      this.focusItemRef = "boxNumberInput";
    },
    clearScanInfo() {
      this.$confirm(this.$t("boxScan.clearConfirm"), this.$t("tip"), {
        type: "warning"
      })
        .then(() => {
          this.scanEntries = [];
          this.scanInfo = {};
          this.resetBoxNumber();
          scanInfoService.clear();
          this.$message({
            type: "success",
            message: this.$t("boxScan.clearSuccess")
          });
        })
        .catch(() => {});
    },
    initializeScanInfo() {
      let info = scanInfoService.read();
      if (info.length) {
        this.scanFlag = scanFlag.EANCODE;
        this.focusItemRef = "eanCodeInput";
        this.currentBoxNumber = info[0].boxNumber;
        this.scanEntries = info;
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("total");
          return;
        }
        if (index === 2 || index === 3) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }
        }
      });
      return sums;
    },
    scanInputBlur() {
      //   this.$refs[this.focusItemRef].focus();
    },
    clearEanScanInfo(ean) {
      this.$confirm(
        this.$t("boxScan.clearEanConfirm", { code: ean }),
        this.$t("tip"),
        {
          type: "warning"
        }
      )
        .then(() => {
          this.scanEntries = this.scanEntries.filter(e => e.eanCode !== ean);
          scanInfoService.clear();
          scanInfoService.write(this.scanEntries);
          this.scanSubmitEntries = scanInfoService.groupBy(this.scanEntries);
          this.$message({
            type: "success",
            message: this.$t("boxScan.clearSuccess")
          });
          this.submitDialogVisible = false;
        })
        .catch(() => {});
    },
    backToScanRecord() {
      this.$router.push({ name: "BoxScan" });
    },
    exportScanInfos() {
      let info = scanInfoService.read();
      console.log("exportScanInfos");
      console.log(info);
      if (info.length) {
        let boxNumber = info[0].boxNumber;
        let blob = new Blob([JSON.stringify(info)], {
          type: "application/json"
        });
        fileSaver.saveAs(blob, `${boxNumber}.json`);
      }
    },
    importScanInfos(file) {
      this.$confirm(this.$t("boxScan.confirmImportScanInfos"), this.$t("tip"), {
        type: "warning"
      })
        .then(() => {
          let reader = new FileReader();
          let onload = function(event) {
            let result = event.target.result;
            try {
              let infos = JSON.parse(result);
              console.log("importScanInfos");
              console.log(infos);
              if (infos instanceof Array && infos.length) {
                let item = infos[0];
                if (
                  item.boxNumber &&
                  item.eanCode &&
                  item.qrCode &&
                  item.eanCodeInfo &&
                  item.eanCodeInfo.EANCode
                ) {
                  scanInfoService.write(infos);
                  this.initializeScanInfo();
                } else {
                  this.$alert(
                    this.$t("boxScan.importScanInfosInvalid"),
                    "错误",
                    {
                      type: "error"
                    }
                  );
                }
              }
            } catch (error) {
              this.$alert(this.$t("boxScan.importScanInfosInvalid"), "错误", {
                type: "error"
              });
            }
          }.bind(this);
          reader.onload = onload;
          reader.readAsText(file);
        })
        .catch(() => {});
      return false;
    }
  },
  computed: {
    canScanBoxNumber() {
      return this.scanFlag === scanFlag.BOXNUMBER;
    },
    canScanEanCode() {
      return this.scanFlag === scanFlag.EANCODE;
    },
    canScanQRCode() {
      return this.scanFlag === scanFlag.QRCODE;
    },
    prependTitle() {
      switch (this.scanFlag) {
        case scanFlag.BOXNUMBER:
          return "箱号";
        case scanFlag.EANCODE:
          return "EAN码";
        case scanFlag.QRCODE:
          return "二维码1";
        default:
          return "箱号";
      }
    },
    loadingIcon() {
      return this.loadingInput ? "el-icon-loading" : "";
    },
    hasScanned() {
      console.log("hasScanned" + !this.scanEntries.length)
      return this.scanEntries.length;
    }
  },
  created() {
    this.initializeScanInfo();

    this.subscription = messageService.getMessage().subscribe(message => {
      console.log("getMess", message.text.boxNumber, message.text.eanCode , message.text.qrCode);
      this.searchEanQRCode(message.text);
    });

  },
  beforeDestroy () {
    if (this.subscription)
      this.subscription.unsubscribe();
  },
  updated() {
    this.$refs[this.focusItemRef].focus();
  }
};
</script>

<style lang="scss">
.boxNumber {
  padding-bottom: 10px;
  font-size: 20px;
}
.delete-btn {
  i {
    font-size: 16px;
  }
  &:hover {
    color: #ff6600;
  }
}
.inline-button-wrapper {
  display: inline-block;
  margin-right: 10px;
  outline: none;
}
</style>









// WEBPACK FOOTER //
// src/components/application/BoxScan/ScanInfo.vue